export default "__VITE_ASSET__B6Xu6FqQ__"